import ApiService from '../apiservice'

export default class TituloAtividadeFaseService extends ApiService {
  constructor() {
    super('/tituloAtividadeFase');
  }

  cadastrar(tituloAtividadeFase) {
    return this.post('/',tituloAtividadeFase);
  }

  listar(titulo) {
    return this.get(`/${titulo}`);
  }

  excluir(titulo,fase) {
    return this.delete(`/excluir?titulo=${titulo}&fase=${fase}`);
  }

  listarNotInTitulo(titulo,empresa) {
    return this.get(`/fasesNotInTitulo?titulo=${titulo}&empresa=${empresa}`);
  }

  consularTituloPorFase(fase) {
    return this.get(`/titulosPorFase/${fase}`);
  }
}